import { Injectable } from '@angular/core';
import { Store, StoreConfig } from '@datorama/akita';

export interface AppStoreState {
  loading: boolean;
  status: {
    message: string;
  } | null;
}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'app' })
export class AppStore extends Store<AppStoreState> {
  constructor() {
    super({
      loading: true,
      status: null,
    });
  }

  override setLoading() {
    this.update({ loading: true });
  }

  clearLoading() {
    this.update({ loading: false });
  }

  setStatus(status: NonNullable<AppStoreState['status']>) {
    this.update({ status, loading: true });
  }

  clearStatus() {
    this.update({ status: null, loading: false });
  }
}
